// == Import npm
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import { Typography } from "antd";

// == Import SCSS
import "./whoAreYou.less";

// == Import assets
import { ReactComponent as Character } from "../../assets/illustrations/character-2.svg";

// == import i18n
import { useTranslation } from "react-i18next";

// == import component
import Tile from "../../common/Tile/Tile";
import { useHistory } from "react-router-dom";

const WhoAreYou = () => {
  const [t] = useTranslation();

  const [display, setDisplay] = useState(true);
  const history = useHistory();

  const { allowBadgeLost } = useSelector(state => state.visits);

  const cssClassDisplay = classNames("searchByResident", {
    "searchByResident--display": !display,
  });

  useEffect(() => {
    if (!allowBadgeLost) history.push("/searchByResident");
  }, [allowBadgeLost, history]);

  const closeBubble = () => {
    setDisplay(true);
  };

  return (
    <div className={cssClassDisplay} onClick={closeBubble} style={{ height: window.innerHeight }}>
      <p className="whoAreYou__texte">
        <Character className="whoAreYou__texte__img" />
        {t("YouAre")}
      </p>

      <section className="searchByResident__section--btn">
        <Tile
          href="/searchByResident"
          style={{
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <Typography.Text style={{ fontSize: 20 }} strong>
            {t("YouAreAVisitor")}
          </Typography.Text>
        </Tile>

        {allowBadgeLost && (
          <Tile
            href="/searchByLostBadge"
            style={{
              height: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "20px",
            }}
          >
            <Typography.Text strong>{t("YouAreAResident")}</Typography.Text>
          </Tile>
        )}
      </section>
    </div>
  );
};

export default WhoAreYou;
